module.exports = "h1 {\r\n    text-align: center;\r\n    font-size: 50px;\r\n}\r\n\r\n.startBtn {\r\n    margin: 3em 10em;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/landing/landing.component.css
// module id = ./src/app/landing/landing.component.css
// module chunks = main